import React from 'react';
import {
  Button,
  Chip,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import { Destination } from '@marageti/z4-sdk/lib/travel';
import { DepartureIcon } from '@marageti/z4-lib';

export type TravelerProfileBucketListViewProps = {
  destinations: Destination[];
  onEdit?: () => void;
};

const TravelerProfileBucketListView = ({
  destinations,
  onEdit,
}: TravelerProfileBucketListViewProps) => {
  const hasDestinations = destinations.length > 0;
  const actionLabel = hasDestinations ? 'Edit Destinations' : '+Add Destinations';

  return (
    <Stack spacing={2} width="100%">
      <Stack direction="row" alignItems="center" spacing={2}>
        <SvgIcon component={DepartureIcon} color="primary" fontSize="small" />
        <Typography variant="body">
          Bucket List Destinations
        </Typography>
      </Stack>

      {hasDestinations ? (
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {destinations.map((destination) => (
            <Chip
              key={destination.id}
              label={destination.name}
              sx={{ backgroundColor: (theme) => theme.palette.common.beige50 }}
            />
          ))}
        </Stack>
      ) : (
        <Typography variant="body" color="common.black50">
          Not recorded
        </Typography>
      )}

      {onEdit && (
        <Button
          variant="text"
          onClick={onEdit}
          sx={{
            typography: 'captionBold',
            color: 'primary.main',
            py: 0.5,
            px: 1,
            alignSelf: 'flex-start',
          }}
        >
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
};

export default TravelerProfileBucketListView;
